import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
	LayoutDashboard,
	Users,
	FolderOpen,
	Settings,
	LogOut,
	Menu,
	X,
} from "lucide-react";

const Dashboard = ({ children }) => {
	const { currentUser, logout, isAdmin } = useAuth();
	const navigate = useNavigate();
	const [sidebarOpen, setSidebarOpen] = useState(true);

	const handleLogout = () => {
		logout();
		navigate("/");
	};

	const menuItems = [
		{
			icon: LayoutDashboard,
			label: "Dashboard",
			path: "/dashboard",
			show: true,
		},
		{
			icon: FolderOpen,
			label: "My Content",
			path: "/dashboard/content",
			show: true,
		},
		{
			icon: Users,
			label: "User Management",
			path: "/dashboard/users",
			show: isAdmin,
		},
		{
			icon: Settings,
			label: "Settings",
			path: "/dashboard/settings",
			show: true,
		},
	];

	return (
		<div className="flex h-screen bg-gray-900">
			{/* Sidebar */}
			<aside
				className={`${
					sidebarOpen ? "w-64" : "w-0"
				} bg-gray-800 border-r border-gray-700 transition-all duration-300 overflow-hidden`}
			>
				<div className="flex flex-col h-full">
					{/* Logo/Brand */}
					<div className="p-6 border-b border-gray-700">
						<h2 className="text-xl font-bold text-white">James Dixon</h2>
						<p className="text-sm text-gray-400 mt-1">Portfolio Dashboard</p>
					</div>

					{/* Navigation */}
					<nav className="flex-1 p-4 space-y-2">
						{menuItems
							.filter((item) => item.show)
							.map((item) => (
								<button
									key={item.path}
									onClick={() => navigate(item.path)}
									className="w-full flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-lg transition-colors"
								>
									<item.icon className="w-5 h-5" />
									<span>{item.label}</span>
								</button>
							))}
					</nav>

					{/* User Info & Logout */}
					<div className="p-4 border-t border-gray-700">
						<div className="mb-3 px-4 py-2 bg-gray-700 rounded-lg">
							<p className="text-sm font-medium text-white">
								{currentUser?.name || "User"}
							</p>
							<p className="text-xs text-gray-400">{currentUser?.email}</p>
							{isAdmin && (
								<span className="inline-block mt-1 px-2 py-0.5 text-xs bg-orange-600 text-white rounded">
									Admin
								</span>
							)}
						</div>
						<button
							onClick={handleLogout}
							className="w-full flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-red-600 hover:text-white rounded-lg transition-colors"
						>
							<LogOut className="w-5 h-5" />
							<span>Logout</span>
						</button>
					</div>
				</div>
			</aside>

			{/* Main Content */}
			<div className="flex-1 flex flex-col overflow-hidden">
				{/* Top Bar */}
				<header className="bg-gray-800 border-b border-gray-700 px-6 py-4">
					<div className="flex items-center justify-between">
						<button
							onClick={() => setSidebarOpen(!sidebarOpen)}
							className="text-gray-400 hover:text-white transition-colors"
						>
							{sidebarOpen ? (
								<X className="w-6 h-6" />
							) : (
								<Menu className="w-6 h-6" />
							)}
						</button>
						<h1 className="text-xl font-semibold text-white">
							{isAdmin ? "Admin Dashboard" : "User Dashboard"}
						</h1>
						<div className="w-6" /> {/* Spacer for centering */}
					</div>
				</header>

				{/* Content Area */}
				<main className="flex-1 overflow-y-auto bg-gray-900 p-6">
					{children}
				</main>
			</div>
		</div>
	);
};

export default Dashboard;
